import React from "react";
import SystemEndUserFrom from "./SystemEndUserFrom";

const AddSystemEndUser = () => {
  return <SystemEndUserFrom />;
};

export default AddSystemEndUser;
